import React from 'react';

interface Props {
  id: string;
  confirmText: string;
  confirmDisabled: boolean;
  onConfirmClick: () => void;
}

class SubmittalSidebarFooter extends React.Component<Props> {
  render(): React.ReactNode {
    const { id, confirmText, confirmDisabled, onConfirmClick } = this.props;

    return (
      <div id={id} className="row justify-end bgd-white-2 px4 py3 shrink-0">
        <button
          id={`${id}-confirm-btn`}
          className="btn btn-primary"
          disabled={confirmDisabled}
          onClick={onConfirmClick}
        >
          {confirmText}
        </button>
      </div>
    );
  }
}

export default SubmittalSidebarFooter;
